import { View, type ViewProps } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import { cn } from "@/shared/lib/utils";

interface ScreenContainerProps extends ViewProps {
  minTopPadding?: number;
  bottomInset?: boolean;
}

export function ScreenContainer({
  children,
  className,
  style,
  minTopPadding = 16,
  bottomInset = true,
  ...props
}: ScreenContainerProps) {
  const insets = useSafeAreaInsets();
  return (
    <View
      className={cn("bg-background flex-1", className)}
      style={[
        {
          paddingTop: Math.max(insets.top, minTopPadding),
          paddingBottom: bottomInset ? insets.bottom : 0,
        },
        style,
      ]}
      {...props}
    >
      {children}
    </View>
  );
}
